import PropTypes from 'prop-types';
import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { SafeRouteValidatorProvider } from 'src/context';
import { paths } from 'src/constants';
import { selectors } from 'src/store';
import { useQuery } from 'src/hooks';

const UnauthorizedValidator = ({ isAuthenticated, children }) => {
  const query = useQuery();
  const redirect = isAuthenticated && (query.get('redirect') || paths.BASE);

  return (
    <SafeRouteValidatorProvider value={redirect}>
      {children}
    </SafeRouteValidatorProvider>
  );
};

UnauthorizedValidator.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
};

const mapStateToProps = (state) => ({
  isAuthenticated: selectors.authentication.getIsAuthenticated(state),
});

export default compose(
  connect(mapStateToProps),
  withRouter
)(UnauthorizedValidator);
